const state = {
  pausedEntry: null
}

const mutations = {
  updatePausedEntry (state, entry) {
    state.pausedEntry = entry
  }
}

const getters = {
  pausedEntry: state => {
    return state.pausedEntry
  }
}

export default {
  state,
  mutations,
  getters
}
